<template>
    <div>
        <header class="header">
            <div class="header__container">
                
                <div class="header__logo">
                <img src="../assets/superkids/superkid-logo.svg" alt="logo">
                </div>

                <nav :class="['header__nav', { active: isOpen }]">
                <ul>
                    <li><a @click="routeTo('/')">Shelta</a></li>
                    <li><a @click="routeTo('/superkids')">Superkids Home</a></li>
                    <li><a @click="routeTo('/weekly-challenges')">Weekly Challenges</a></li>
                    <!-- <li><a href="#">Fetivals</a></li> -->
                    <!-- <li><a href="#">Contact</a></li> -->
                </ul>
                </nav>

                <div class="header__action">
                <button class="register-btn btn" @click="routeTo('/dashboard/superkid-register')">Register Now</button>
                </div>

                <!-- Mobile toggle -->
                <div class="header__toggle" @click="toggleMenu">
                ☰
                </div>

            </div>
        </header>
    </div>
</template>


<script>
// import AuthNavbar from "./AuthNavbar";
export default {
  name: "SuperKidPublicHeader",
  components: {

  },
  data() {
    return {
      email: null,
      isOpen: false
    };
  },
  watch: {
        $route() {
            this.isOpen = false;
        }
    },
    mounted() {
      // this.email = JSON.parse(localStorage.getItem("shelta-user")).email,
      const userEmail =  localStorage.getItem("shelta-user");
      if (userEmail && userEmail !== "undefined") {
        const user = JSON.parse(userEmail);
        this.email = user.email;
      }
      window.addEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy() {
        // Important: Clean up to avoid memory leaks
        window.removeEventListener('keydown', this.handleKeyDown);
    },
  //  mounted() {
  //    this.email = JSON.parse(localStorage.getItem("shelta-user")).email
  //    console.log("Email", this.email);
  //  }
  methods: {
    routeTo(route) {
        this.$router
        .push({
            path: route
            })
            .catch(() => {
            // console.log("none")
        });
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    scroll(direction) {
      const container = this.$refs.scrollContainer;
      // Scrolls by the visible width of the container
      const distance = container.clientWidth; 

      if (direction === 'left') {
        container.scrollBy({ left: -distance, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: distance, behavior: 'smooth' });
      }
    },
    handleKeyDown(e) {
      if (e.key === 'ArrowRight') this.scroll('right');
      if (e.key === 'ArrowLeft') this.scroll('left');
    }
  }
};
</script>


<style lang="scss" scoped>
.header {
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 1000;

  &__container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    height: 80px;
  }

  &__logo {
    font-size: 1.5rem;
    font-weight: bold;
  }

  &__nav {
    flex: 1;
    display: flex;
    justify-content: center;

    ul {
      display: flex;
      gap: 30px;
      list-style: none;
      padding: 0;
      margin: 0;

      li a {
        text-decoration: none;
        color: #1C2B3A;
        font-weight: 500;
        transition: color 0.3s;
        font-family: Poppins;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          color: #2EBFCA;
        }
      }
    }
  }

  &__action {
    .register-btn {
        font-family: Lato;
        font-weight: 600;
        min-height: 50px;
        font-size: 18px;
        color: #ffffff;
        background: #2EBFCA;
        border-radius: 50px;
        width: 164px;
      transition: 0.3s;

      &:hover {
        background: #0056b3;
      }
    }
  }

  &__toggle {
    display: none;
    font-size: 24px;
    cursor: pointer;
  }
}

/* =========================
   Responsive Styles
========================= */
@media (max-width: 768px) {
  .header {

    &__container {
      height: 60px;
    }

    &__nav {
      position: absolute;
      top: 60px;
      left: 0;
      width: 100%;
      background: #fff;
      display: none;
      flex-direction: column;
      align-items: center;
      box-shadow: 0 5px 10px rgba(0,0,0,0.05);

      ul {
        flex-direction: column;
        gap: 15px;
        padding: 20px 0;
      }
    }

    &__nav.active {
      display: flex;
    }

    &__action {
      display: none;
    }

    &__toggle {
      display: block;
    }
  }
}

</style>